import {AxiosResponse} from "axios";

import ResourceApi from "@/src/modules/core/api/resource-api";
import type {GetResponse} from "@/src/modules/core/types";

import type {
  Citation,
  CreateCitationPayload,
  PatchTowDispatchPayload,
  UpdateCitationPayload,
  UploadCitationProofPayload,
} from "../types";

const PATH = "citation";

class CitationsApi extends ResourceApi<Citation> {
  constructor() {
    super(PATH);
  }

  create(data: CreateCitationPayload): Promise<AxiosResponse<GetResponse<Citation>>> {
    return super.create(data);
  }

  update(id: number, data: UpdateCitationPayload): Promise<AxiosResponse<GetResponse<Citation>>> {
    return super.update(id, data);
  }

  uploadProofs(
    citationId: number,
    data: UploadCitationProofPayload,
  ): Promise<AxiosResponse<GetResponse<Citation>>> {
    return this.createAt(`${PATH}/${citationId}/proofs`, data);
  }

  patchTowDispatch(
    citationId: number,
    data: PatchTowDispatchPayload,
  ): Promise<AxiosResponse<GetResponse<Citation>>> {
    return this.updateAt(`${PATH}/${citationId}/tow-dispatch`, "", data);
  }
}

export const citationsApi = new CitationsApi();
